/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from '@module-logger/mbp';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import { compose } from 'recompose';
import { GRAPHQL_ENV } from '../../../gql';

import Entry from './Entry';
import RecipeSkeleton from '../GraphqlSkeletonComponents/RecipeSkeleton';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';

const RecipeEntry = ({ page, brand }) => {
    if (!page) return null;
    const RECIPE_ENTRY_QUERY = gql`
            query RECIPE_ENTRY_QUERY {
                findContentPage(brand: "${brand['domain-name']}", url: "${page.path}", contentType: "recipe_entry", environment: "${GRAPHQL_ENV}", locale: "en-us") {
                    content
                }
            }
        `;
    return (
        <Query query={RECIPE_ENTRY_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <RecipeSkeleton />; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: RECIPE_ENTRY_QUERY,
                        component: 'GraphqlDepartmentPage.js',
                        message: `Error loading data for recipe "${page.path}"`,
                        env: GRAPHQL_ENV,
                        error,
                    });

                    return null;
                }

                if (!data?.findContentPage?.content) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: RECIPE_ENTRY_QUERY,
                        component: 'GraphqlDepartmentPage.js',
                        message: `No data returned for recipe "${page.path}"`,
                    });
                    return null;
                }

                const recipeData = data?.findContentPage?.content?.entries?.[0];
                return (
                    <Entry
                        page={page}
                        recipeData={recipeData}
                    />
                );
            }}
        </Query>
    );
};

const mapStateToProps = (state) => ({
    data: object.isRequired,
    brand: getBrand(state),
});

RecipeEntry.propTypes = {
    page: object.isRequired,
    brand: object.isRequired,
};

const enhance = compose(
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(RecipeEntry);
